import styles from './CalculatorPage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect, shallowEqual } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import { Transfer } from '../common/transfer/Transfer';
import { Rates } from '../common/rates/Rates';
import { RecentTranscation } from '../common/recent-transcation/Recent-Transcation';
import { commonActions, ratesActions } from '../../stores/_actions';
import { ProfileBar } from 'views/components/profile-bar/ProfileBar';
import Label from '../../constants/Label';
import Validator from '../common/common-functions';
function CalculatorPage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));

  const dispatch = useDispatch();
  const history = useHistory();

  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      FromAmount: '',
      FromCurrency: '',
      ToCurrency: '',
      CustomerCode: profile?.CustomerCode,
    },
  });

  useEffect(() => {
    dispatch(commonActions.currency());
    dispatch(commonActions.getCustDetailsByCode(payload));
    dispatch(ratesActions.clearRatesData());
    dispatch(ratesActions.clearCalCur());
  }, []);

  let [LCAmount, lcAmount] = useState(false);
  let [RCAmount, rcAmount] = useState(false);
  let [errorMsg, setErrorMsg] = useState(false);
  let [errorRCMsg, setErrorRCMsg] = useState(false);

  const [lcFlag, setFCFlag] = useState('');
  const [rcFlag, setRCFlag] = useState('');
  const [currencyR, setRCFlagImg] = useState('');
  const [receiveAmount, setReceiveAmount] = useState();
  const [sendAmount, setSendAmount] = useState();
  const [focusSet, setFocus] = useState(false);

  const currency = useSelector((state) => state.currency.data);

  const youSendLCFlag = (event, items) => {
    lcAmount(!LCAmount);
    setFCFlag((lcFlag) => (lcFlag = profile?.CurrencyCode1));
    // setFCFlagImg((currencyL) => (currencyL = items.CurrencyFlagPath));
  };

  const recieveRCFlag = (event, items) => {
    rcAmount(!RCAmount);
    setRCFlag((rcFlag) => (rcFlag = items.ID));
    setRCFlagImg((currencyR) => (currencyR = items.CurrencyFlagPath));
    const sendAmt = document.getElementById('sendAmount').value;
    AmountCalculateLC(sendAmt, items.ID);
  };

  const RCFlaglist =
    currency &&
    currency.map((items) => (
      <a key={items.ID} id={items.ID} data={JSON.stringify(items)} onClick={(e) => recieveRCFlag(this, items)}>
        <img src={items.CurrencyFlagPath} /> {items.ID}
      </a>
    ));

  let currencyCalc;
  useSelector((state) => {
    currencyCalc = state.currencyCalc?.data;
    setTimeout(() => {
      focusSet == true
        ? setReceiveAmount((receiveAmount) => (receiveAmount = currencyCalc?.ToAmount))
        : setSendAmount((sendAmount) => (sendAmount = currencyCalc?.ToAmount));
    }, 100);
  });

  const AmountCalculateRC = (amount) => {
    setErrorRCMsg('');
    if (!rcFlag) {
      setErrorMsg('Please select They Receive Currency');
    }
    const checkNumber = Validator.currencyValidate(amount.value);
    // if (!checkNumber && amount.value) {
    //   setReceiveAmount(payload.prevRCAmount);
    //   const numAfterDeciml = String(amount.value).split('.');
    //   if (numAfterDeciml[1]) {
    //     if (Number(numAfterDeciml[1].length) > 3) setErrorRCMsg('Value after decimal cannot exceed 3 digits!');
    //     else setErrorRCMsg('Amount is required & can be digits only!');
    //   } else setErrorRCMsg('Amount is required & can be digits only!');
    //   return;
    // }
    if (checkNumber && amount.value) {
      const numAfterDeciml = String(amount.value).split('.');
      if (numAfterDeciml[1]) {
        if (Number(numAfterDeciml[1].length) > 3) {
          setErrorRCMsg('Value after decimal cannot exceed 3 digits!');
          return;
        }
      }
    } else if (!checkNumber && amount.value) {
      setErrorRCMsg('Amount is required & can be digits only!');
      return;
    }
    setFocus(false);
    setReceiveAmount(amount.value);
    payload.prevRCAmount = amount.value;
    payload.Data['FromAmount'] = amount.value;
    payload.Data['ToCurrency'] = profile?.CurrencyCode1;
    payload.Data['FromCurrency'] = rcFlag;
    setPayload((payload) => ({ ...payload }));
    dispatch(ratesActions.getCurrencyCalc(payload));
  };
  const AmountCalculateLC = (amount, toCur = null, evt = null) => {
    setErrorMsg('');
    if (evt && amount?.value && !rcFlag) {
      setErrorMsg('Please select They Receive Currency');
    }
    const checkNumber = Validator.currencyValidate(evt ? amount?.value : amount);
    // if (!checkNumber && (evt ? amount?.value : amount)) {
    //   setSendAmount(evt ? amount?.value : amount);
    //   const numAfterDeciml = String(amount.value || amount).split('.');
    //   if (numAfterDeciml[1]) {
    //     if (Number(numAfterDeciml[1].length) > 3) setErrorMsg('Value after decimal cannot exceed 3 digits!');
    //     else setErrorMsg('Amount is required & can be digits only!');
    //   } else setErrorMsg('Amount is required & can be digits only!');
    //   payload.Data['Amount'] = ' ';
    //   return;
    // }
    if (checkNumber && (evt ? amount?.value : amount)) {
      const numAfterDeciml = String(amount.value || amount).split('.');
      if (numAfterDeciml[1]) {
        if (Number(numAfterDeciml[1].length) > 3) {
          setErrorMsg('Value after decimal cannot exceed 3 digits!');
          return;
        }
      }
    } else if (!checkNumber && amount.value) {
      setErrorMsg('Amount is required & can be digits only!');
      return;
    }
    setFocus((focusSet) => true);
    setSendAmount(evt ? amount?.value : amount);
    payload.prevSendAmount = evt ? amount?.value : amount;
    payload.Data['FromAmount'] = evt ? amount?.value : amount;
    payload.Data['ToCurrency'] = amount.value ? rcFlag : toCur;
    payload.Data['FromCurrency'] = profile?.CurrencyCode1;
    setPayload((payload) => ({ ...payload }));
    dispatch(ratesActions.getCurrencyCalc(payload));
  };

  function empty(e) {
    e.preventDefault();
    if (e.target.name == 'sendAmount') {
      setReceiveAmount((receiveAmount) => (receiveAmount = 0));
      return;
    } else {
      setSendAmount((sendAmount) => (sendAmount = 0));
      return;
    }
  }
  const userProfile = useSelector((state) => state.getCustDetails.data);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.pageLeft__transferRates}>
                <div className={styles.calcuLeft}>
                  <div className={styles.pageLeft__transfer}>
                    <h2>{Label.Calculator.heading}</h2>
                    <div className={styles.formGroup}>
                      <label>You Send</label>
                      <div className={styles.currencyConv}>
                        <input
                          type="text"
                          name="sendAmount"
                          id="sendAmount"
                          value={sendAmount}
                          autoComplete="off"
                          // onFocus={empty}
                          onChange={(e) => AmountCalculateLC(e.target, null, 'change')}
                          maxLength="13"
                        />
                        <div className={styles.currencyConv__flag}>
                          <div>
                            <button type="button" onClick={() => lcAmount(!LCAmount)}>
                              {profile?.CurrencyCode1}
                            </button>
                            {/* <div className={styles.dropdown__droppop + ` ` + `${LCAmount ? styles.show : styles.hide}`}>{LCFlaglist}</div> */}
                          </div>
                          <img src={profile?.CurrencyFlagPath1} alt="" />
                        </div>
                      </div>
                      <div className={styles.formgroup__error}>{errorMsg}</div>
                      {/* {errorMsg && rcFlag == '' ? (
                        <div className={styles.formgroup__error}>
                          <h5>{Label.Calculator.heading3}</h5>
                        </div>
                      ) : (
                        ''
                      )} */}
                    </div>
                    <div className={styles.formGroup}>
                      <label>they receive</label>
                      <div className={styles.currencyConv}>
                        <input
                          type="text"
                          name="recieveAmount"
                          id="receiveAmount"
                          autoComplete="off"
                          value={receiveAmount}
                          // onFocus={empty}
                          onChange={(e) => AmountCalculateRC(e.target)}
                        />
                        <div className={styles.currencyConv__flag}>
                          <div className={styles.dropdown}>
                            <button type="button" onClick={() => rcAmount(!RCAmount)}>
                              {rcFlag}
                            </button>
                            <div className={styles.dropdown__droppop + ` ` + `${RCAmount ? styles.show : styles.hide}`}>{RCFlaglist}</div>
                          </div>
                          <img src={currencyR} alt="" />
                        </div>
                      </div>
                      <div className={styles.formgroup__error}>{errorRCMsg}</div>
                      {errorRCMsg && rcFlag == '' ? (
                        <div className={styles.formgroup__error}>
                          <h5>{Label.Calculator.heading4}</h5>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <Transfer />
                </div>
                <Rates />
              </div>
            </div>
            <RecentTranscation />
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { CalculatorPage };
